const OrchardTypeArr = [
  { name: '1.0', value: '1.0' },
  { name: '1.0.1', value: '1.0.1' },
  { name: '1.0.2', value: '1.0.2' },
  { name: '2.0', value: '2.0' },
  { name: '2.0.1', value: '2.0.1' },
  { name: '2.0.2', value: '2.0.2' },
  { name: '3.0', value: '3.0' },
  { name: '3.1', value: '3.1' },
  { name: '4.1', value: '4.1' },
  { name: '4.2', value: '4.2' },
  { name: '4.3', value: '4.3' },
  { name: '5.1', value: '5.1' },
  { name: '5.2', value: '5.2' },
  { name: '5.3', value: '5.3' },
  { name: '6.1', value: '6.1' },
  { name: '6.2', value: '6.2' },
  { name: '6.3', value: '6.3' },
  { name: '7.1', value: '7.1' },
  { name: '7.2', value: '7.2' },
  { name: '7.3', value: '7.3' }
];
  const ElevationArr = [
    { name: 'LO', value: 'LO' },
    { name: 'MID', value: 'MID' },
    { name: 'HI', value: 'HI' }
  ];
  
  const SpeciesArr = [
    { name: 'DF', value: 'DF' },
    { name: 'LOBLOLLY', value: 'LB' },
    { name: 'NF', value: 'NF' },
    { name: 'SLASH', value: 'SL' }
  ];
  
  const BlockCycleArr = [
    { name: 'Odd', value: 'O' },
    { name: 'Even', value: 'E' },
    { name: 'Split', value: 'S' },
    { name: 'Other', value: 'Z' }
  ];
  
  const StimCycleArr = [
    { name: 'Odd', value: 'O' },
    { name: 'Even', value: 'E' },
    { name: 'Other', value: 'Z' }
  ];
  
  const StimStatusArr = [
    { name: 'Active', value: 'A' },
    { name: 'Suspended', value: 'S' }
  ];
  
  const BreedingAreaArr = [
    { name: 'Cascade', value: 'CA' },
    { name: 'Coos Bay', value: 'CB' },
    { name: 'Central-East Breeding and Deployment Zone', value: 'CE' },
    { name: 'Columbia', value: 'CO' },
    { name: 'Longview', value: 'LV' },
    { name: 'Northwest Breeding and Deployment Zone', value: 'NW' },
    { name: 'Oregon', value: 'OR' },
    { name: 'Piedmont Seed Source', value: 'PMT' },
    { name: 'Southeast Breeding and Deployment Zone', value: 'SE' },
    { name: 'Slash Pine', value: 'SLASH' },
    { name: 'Springfield', value: 'SP' },
    { name: 'Twin Harbors', value: 'TH' },
    { name: 'Vail', value: 'VA' },
    { name: 'Washington', value: 'WA' },
    { name: 'Washington Costal', value: 'WC' },
    { name: 'Washington Inland', value: 'WI' }
  ];
  
  const PositionArr = [
    { name: '0', value: '0' },
    { name: 'A', value: 'A' },
    { name: 'P', value: 'P' },
    { name: 'Perm', value: 'Z' }
  ];
  
  export {
    OrchardTypeArr,
    ElevationArr,
    SpeciesArr,
    BlockCycleArr,
    StimCycleArr,
    StimStatusArr,
    BreedingAreaArr,
    PositionArr
  };
  